import createHeadingId from "./createHeadingId";
import isEmpty from "./isEmpty";

export { createHeadingId, isEmpty };
